import { fromEvent, merge, Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

export function getTreatment<T>(
  client: SplitIO.IClient,
  name: string,
): Observable<T> {
  return merge(
    fromEvent(client, client.Event.SDK_UPDATE),
    fromEvent(client, client.Event.SDK_READY),
  ).pipe(
    startWith(undefined),
    map(() => client.getTreatment(name) as unknown as T),
  );
}
